// Components==============
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TrainingCollapseCard from 'components/UI/TrainingCollapseCard/TrainingCollapseCard';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import { getTrainingIsCompleted } from 'pages/Workspace/TrainingDetails/components/getTrainingIsCompleted';
import React from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import './SessionCard.module.scss';
// =========================

export default function SessionCard({
  session,
  sessionId,
  training,
  subscriber,
  locked,
}: {
  session?: TrainingSessionEntity;
  sessionId?: number;
  training?: TrainingEntity;
  subscriber?: TrainingSubscriptionEntity;
  locked?: boolean;
}) {
  const translate = useTranslate();

  const sessionIdList = training?.sessions
    ?.sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
    .map((s) => s.id);

  const currentIdIndex = sessionIdList?.indexOf(sessionId!) || 0;

  const completedLessons = session?.lessons?.filter((lesson) => {
    const attendance = subscriber?.attendances?.find(
      (a) => a.lesson_id === lesson.id
    );

    return getTrainingIsCompleted(lesson, attendance, subscriber?.user_id);
  });

  return (
    <div style={{ opacity: locked ? 0.5 : 1 }}>
      <TrainingCollapseCard
        locked={locked}
        sessionIndex={currentIdIndex + 1}
        background={session?.image}
        left={
          <div styleName="left">
            <div styleName="bar" />
            <div>
              <div styleName="title">
                {!!session?.lessons?.length && (
                  <AnimatePresence>
                    {!!(
                      completedLessons?.length === session?.lessons.length
                    ) && (
                      <motion.div {...framerFade}>
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </motion.div>
                    )}
                  </AnimatePresence>
                )}
                <h2>{session?.title}</h2>
              </div>
              {!!session?.lessons?.length && (
                <p styleName="lesson">
                  {session?.lessons.length}{' '}
                  {session?.lessons.length > 1
                    ? translate('course.terms.lessons')
                    : translate('course.terms.lesson')}
                </p>
              )}
            </div>
          </div>
        }
      >
        <>{session?.description}</>
      </TrainingCollapseCard>
    </div>
  );
}
